<ic-container class="no-header" [loading]="!form">
	@if (form) {
		<section [formGroup]="form">
			<h1 class="ic-form-title">{{ "katz.labels.base" | translate }}</h1>
			<div class="base">
				<table>
					<thead>
						<th></th>
						@for (value of values; track value) {
							<th>{{ value }}</th>
						}
					</thead>
					<tbody>
						@for (step of baseSteps; track step) {
							<tr
								#rowError="icNgxErrors"
								[class.error]="rowError.hasError('*', 'touched')"
								[icNgxErrors]="step"
								[ngxErrors]="step"
							>
								<td>
									<strong> {{ "katz.labels." + step | translate }} </strong>
								</td>
								@for (value of values; track value) {
									<td [class.active]="form.get(step).value === value">
										<label>
											<input type="radio" [formControlName]="step" [name]="step" [value]="value" />
											{{ "katz.values." + step + "." + value | translate }}
										</label>
									</td>
								}
							</tr>
						}
					</tbody>
				</table>
			</div>
			<h1 class="ic-form-title">{{ "katz.labels.orientation" | translate }}</h1>
			<div class="orientation">
				<table>
					<thead>
						<th></th>
						@for (value of values; track value) {
							<th>{{ value }}</th>
						}
					</thead>
					<tbody>
						@for (step of orientationSteps; track step) {
							<tr
								#rowError="icNgxErrors"
								[class.error]="rowError.hasError('*', 'touched')"
								[icNgxErrors]="step"
								[ngxErrors]="step"
							>
								<td>
									<strong> {{ "katz.labels." + step | translate }} </strong>
								</td>
								@for (value of values; track value) {
									<td [class.active]="form.get(step).value === value">
										<label>
											<input type="radio" [formControlName]="step" [name]="step" [value]="value" />
											{{ "katz.values.orientation." + value | translate }}
										</label>
									</td>
								}
							</tr>
						}
					</tbody>
				</table>
			</div>
		</section>
	}
	<section class="indication">
		<h1 class="ic-form-title">{{ "katz.labels.indication" | translate }}: {{ katzInfo | katz }}</h1>
	</section>
</ic-container>
